import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@src/lib/utils/cn";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    indicatorClassName?: string;
    /**
     * "translate" (default) slides a full-width fill left and lets the track
     * clip it. "width" sizes the fill to the value instead, so a padded track
     * keeps the fill inside its inset and both ends stay rounded.
     */
    fillMode?: "translate" | "width";
  }
>(
  (
    { className, indicatorClassName, value, fillMode = "translate", ...props },
    ref,
  ) => (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
        className,
      )}
      value={value}
      {...props}
    >
      {fillMode === "width" ? (
        <ProgressPrimitive.Indicator
          className={cn(
            "h-full bg-primary transition-[width]",
            indicatorClassName,
          )}
          style={{ width: `${Math.min(100, Math.max(0, value || 0))}%` }}
        />
      ) : (
        <ProgressPrimitive.Indicator
          className={cn(
            "h-full w-full flex-1 bg-primary transition-all",
            indicatorClassName,
          )}
          style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
      )}
    </ProgressPrimitive.Root>
  ),
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
